<button
  [matMenuTriggerFor]="panel.menu"
  mat-stroked-button
  color="primary"
>
  <span class="mr-05">Actions</span>
  <fa-icon class="ml-a" [icon]="['fas', 'chevron-down']"></fa-icon>
</button>
<menu-panel #panel [items]="menuItems" [panelClass]="'manage-plan'"></menu-panel>
